import { defineMessages } from 'react-intl';

export default defineMessages({
  contractEtGarantie: {
    id: 'auto_details.contract_garantie',
  },
  adhesion: {
    id: 'sante_details.contract_garantie',
  },
  suiviDeSinistre: {
    id: 'auto_details.suivi_sinistre',
  },
  mesReleveDeSituation: {
    id: 'dashboard_epargn.releve_situation',
  },
  mesContrats: {
    id: 'dashboard_epargn.contrats',
  },
  mesRemboursements: {
    id: 'amc_details.my_refunds',
  },
  suiviDesDemandes: {
    id: 'amc_details.requests_follow_up',
  },
  suiviDesDemandesResp: {
    id: 'amc_details.requests_follow_up_resp',
  },
  suiviPAC: {
    id: 'Home_text_Health_mes_declaration',
  },
  suiviPACResp: {
    id: 'Home_text_Health_mes_declaration_resp',
  },
});
